import { FormAnswerStatus } from '@tabeeb/contracts/main-api/swagger-main-api'

export const AnswerStatusesDisplayName = {
  [FormAnswerStatus.Pending]: 'Submitted',
  [FormAnswerStatus.Pass]: 'Approved',
  [FormAnswerStatus.Fail]: 'Rejected',
  [FormAnswerStatus.Empty]: 'No action',
  [FormAnswerStatus.ApprovedByAI]: 'Approved by AI',
  [FormAnswerStatus.RejectedByAI]: 'Rejected by AI',
  [FormAnswerStatus.ApprovedByReviewer]: 'Approved by a reviewer',
  [FormAnswerStatus.RejectedByReviewer]: 'Rejected by a reviewer',
}
